import Component from '../core/Component'

export default class CartBoxOpener extends Component {
    constructor(element,options={}) {
        super(element,options)

        this.enquireHandler = {
            match: this.isMobile
        }
    }
    prepare() {
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('click', this.handleClick)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
    }

    handleClick = event => {
        if (this.isMobile) {
            return
        }
        this.showCartBox()
    }

    handleMouseEnter = event => {
        this.showCartBox()
    }

    handleMouseLeave = event => {
        this.hideCartBox()
    }

    showCartBox() {
        const cartBox = Component.getFromElement('cart-box')
        if (!cartBox) {
            return
        }

        const rect = this.element.getBoundingClientRect()
        cartBox.show({
            x: rect.left,
            y: rect.top,
            width: rect.width,
            height: rect.height,
            viewType: this.element.dataset.viewtype
        })
    }

    hideCartBox() {
        const cartBox = Component.getFromElement('cart-box')
        if (!cartBox) {
            return
        }

        cartBox.hide()
    }
}